// Free / temporary email providers not allowed for business accounts.
// Copied 1:1 from @vnetwork/ui templates/Register.tsx. Shared by the register
// blocked-domains dialog (RegisterPage) and the business lead-form validation
// (BusinessLeadRegister).
export const BLOCKED_DOMAINS = [
  'gmail.com', 'googlemail.com', 'yahoo.com', 'ymail.com', 'hotmail.com',
  'outlook.com', 'live.com', 'icloud.com', 'aol.com', 'proton.me',
  'protonmail.com', 'mail.com', 'gmx.com', 'zoho.com', 'yandex.com',
  'mailinator.com', '10minutemail.com', 'guerrillamail.com', 'tempmail.com',
  'throwawaymail.com', 'trashmail.com', 'sharklasers.com', 'getnada.com',
  'dispostable.com',
];

/** True when the email's domain is a blocked free/temporary provider. */
export function isBlockedEmail(email: string): boolean {
  const at = email.lastIndexOf('@');
  if (at < 0) return false;
  const domain = email.slice(at + 1).trim().toLowerCase();
  return BLOCKED_DOMAINS.includes(domain);
}
